//@ts-check
import React from 'react';
import PageError from '../../page/Error';
import PageNavBar from '../../page/NavBar/NavBar';
import InstallationPage from '../../page/Settings/Installation/InstallationPage';
import Loader from '../../page/Settings/Installation/Loader';
import useInstallationBootstrap from './useInstallationBootstrap';
import InstallationContext from './InstallationContext';
import withManifest from '../manifest/withManifest';
/**
 * @param {import('./types').AppsInstallationProps & import('core/EcrionProvider/types').WithManifest} props
 */

var InstallationProvider = function InstallationProvider(_ref) {
  var children = _ref.children,
      history = _ref.history,
      RedirectComponent = _ref.RedirectComponent,
      setting = _ref.setting,
      settingValue = _ref.settingValue,
      form = _ref.form,
      path = _ref.path,
      resetPath = _ref.resetPath,
      manifest = _ref.manifest;
  var state = useInstallationBootstrap(setting, settingValue);

  if (state.loading) {
    return React.createElement(React.Fragment, null, React.createElement(PageNavBar, null), React.createElement(Loader, null));
  }

  if (state.error) {
    return React.createElement(PageError, {
      title: state.error.title,
      message: state.error.details
    });
  }

  if (!history) return children;
  var location = history.location;
  if (typeof location.pathname !== 'string') return children;

  if (location.pathname.startsWith(path) || location.pathname.startsWith(resetPath)) {
    return React.createElement(InstallationPage, {
      history: history,
      location: location,
      resetPath: resetPath,
      appName: manifest.Name,
      appIcon: manifest.IconURL,
      FormComponent: form,
      RedirectComponent: RedirectComponent,
      onSuccess: function onSuccess() {
        state.reset();
      }
    });
  }

  if (state.value === null) {
    //defensive check
    if (!RedirectComponent) return children; //not installed, bootstrap

    return React.createElement(RedirectComponent, {
      to: path
    });
  }

  return React.createElement(InstallationContext.Provider, {
    value: state
  }, children);
};

InstallationProvider.defaultProps = {
  setting: 'installation',
  settingValue: function settingValue(v) {
    return v;
  },
  path: '/installation',
  resetPath: '/installation/reset',
  appName: undefined,
  appIcon: undefined,
  form: null
};
export default withManifest(InstallationProvider);